<template>
    <div class="TopNav">
       <a :href="item.url" v-for="item in navList" :index="item.text">{{ item.text }}</a>
    </div>
</template>

<script>
export default {
    name: 'TopNav' ,
    components: { 
    },
    data() {
        return {
            navList:[
                {text: "招标公告", url: "/zbgg/"},
                {text: "招标预告", url: "/zbyg/"},
                {text: "中标结果", url: "/zbjg/"},
                {text: "招标变更", url: "/zbbg/"},
            ]
        };
    },
};
</script>

<style  lang="scss">
.TopNav{
    width: 100%;
    height:48px;
    line-height: 48px;
    padding:0 10px;
    background: #e60012;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    a{
        display: block;
        color: #fff;
        padding: 0 10px;
        font-size: 14px;
    }
}
</style>
